import React from 'react';
import AuthService from './authService.js';
import NewProjectItem from '../Domain/ThirdParty/Project/NewProjectItem';
import SearchParams from '../Elements/SearchParams';
import ProjectSearchParams from '../Contents/ThirdParty/Project/ProjectSearchParams';

export default class NewProjectService extends React.Component {
  static GetAllItemBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      ProjectSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    const url = `/api/TpProject/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new NewProjectItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static CreateNewProject(newProject) {
    const url = 'api/TpProject/CreateNewProject/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, JSON.stringify(newProject));
  }

  static SaveEditedProject(selectedItem) {
    const url = 'api/TpProject/UpdateProject/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(selectedItem));
  }

  static ToggleWaveLinking(selectedItem) {
    const url = 'api/TpProject/ToggleWaveLinking/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(selectedItem));
  }

  static GetPlatformCostOverride(projectId) {
    const url = `/api/TpProject/GetPlatformCostOverride/${projectId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static UpsertPlatformCostOverride(edited) {
    const url = 'api/TpProject/UpsertPlatformCostOverride/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(edited));
  }

  static DeletePlatformCostOverride(projectId) {
    const url = `/api/TpProject/DeletePlatformCostOverride/${projectId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionDelete(url);
  }

  static RunPlatformCostBilling() {
    const url = 'api/TpProject/RunPlatformCostBilling/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, JSON.stringify({}));
  }

  static GetProjectsByClientId(clientId) {
    const url = `api/TpProject/GetProjectsByClientId/${clientId ?? 0}?clearCache=true`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static GetProjectList(
    projectId,
    clientIdFilter,
    projectIdFilter,
    opportunityIdFilter,
    surveyIdFilter,
    tpProjectIdFilter,
    tpSurveyIdFilter
  ) {
    const searchItem = {
      ClientId: clientIdFilter,
      ProjectId: projectIdFilter,
      OpportunityId: opportunityIdFilter,
      SurveyId: surveyIdFilter,
      TpProjectId: tpProjectIdFilter,
      TpSurveyId: tpSurveyIdFilter,
    };

    let url = '/api/TpProject';

    if (projectId != null && projectId !== -1) {
      url += `/GetProjectById/${projectId}?clearCache=true`;
    } else {
      url += `/GetProjectSelectList?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    }

    return AuthService.getInstance().CallBackendFunction(url);
  }
}
